'use client';

import React from 'react';
import BrandPanel from '@/app/login-screen/components/BrandPanel';
import RegisterForm from './RegisterForm';
import Image from 'next/image';

export default function RegisterPageContent() {
  return (
    <div className="min-h-screen flex bg-background">
      {/* Brand Panel — left side on desktop */}
      <BrandPanel />

      {/* Form Panel — right side */}
      <div className="flex-1 flex items-center justify-center p-6 lg:p-12 min-h-screen">
        <div className="w-full max-w-lg fade-in">
          {/* Mobile logo */}
          <div className="flex flex-col items-center mb-8 lg:hidden">
            <div className="flex items-center justify-center mb-3">
              <Image
                src="/assets/images/Lazos_Leis-1783991105659.png"
                alt="Lazos Leis Logo"
                width={150}
                height={150}
                className="object-contain"
              />
            </div>
          </div>

          <RegisterForm />
        </div>
      </div>
    </div>
  );
}
